class RealBrides extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.onClick = this.onClick.bind(this)
    this.onReveal = this.onReveal.bind(this)

    this?.els?.image?.elements.forEach(imageEl => {
      imageEl.addEventListener('click', this.onClick)
    })

    this?.els?.trigger?.element.addEventListener('click', this.onReveal)
  }

  onClick (e) {
    const currentImageEl = e.target.closest(this.els?.image?.selector)

    this?.els?.card?.elements.forEach(cardEl => {
      cardEl.setAttribute(
        'aria-current',
        cardEl.dataset.index === currentImageEl.dataset.index,
      )
    })

    this?.els?.image?.elements.forEach(imageEl => {
      imageEl.setAttribute(
        'aria-current',
        imageEl.dataset.index === currentImageEl.dataset.index,
      )
    })
  }

  onReveal () {
    this?.els?.container?.element.setAttribute('aria-expanded', true)
    this?.els?.trigger?.element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('real-brides')) {
  customElements.define('real-brides', RealBrides)
}
